const Theme6572 = {
  logoType: 'img',
  logo: "https://assets.lmscourses.com/logos/sgws-logo-full.png",

  background: "#d2d2d2",
  backgroundGradient: `linear-gradient(0deg, #e8e8e8 0%, #FFFFFF 40%)`,

  fontColor: "#333333",
  fontColorLight: "#333333", // for the requirements page & footer... to contrast background color

  linkColor: "#A11F23",
  linkHover: "#691a30",
  linkActive: "#6f1c33",

  buttonText: "#FFFFFF",
  buttonTextHover: null,

  svgColor: "#333333",
  svgHover: "#0072C0",

  mainColor: "#A11F23",
  secondaryColor: "#D4B45A",

  linksNavBackground: "#000000",
  linksNavLinks: "#FFFFFF",
  linksNavHover: "#5DB7EA",

  borderColor: "#c7c7c7",

  topNavBackground: "#FFFFFF",
  topNavHoverBg: "#e9e9e9",
  topNavGradient: null,
  topNavText: "#333333",
  topNavTextHover: "#0072C0",
  topNavSVG: "#333333",
  topNavSVGHover: "#A11F23",

  subNavBackground: "#FFFFFF",
  subNavGradient: null,
  subNavText: "#333333",
  subNavTextHover: null,
  subNavBackgroundHover: "#e9e9e9",

  sideNavigationBackground: "#000000",
  sideNavigationText: "#FFFFFF",
  sideNavigationHover: "#f2d57d",
  sideNavActive: "#D4B45A",

  homeOverlay: "#2994de",
}

export default Theme6572
